export enum SourceType {
  EFT_WEB = 'EFT_WEB',
  UPLOAD = 'UPLOAD',
  CPS_WEB = 'CPS_WEB',
  FILE_ENTRY = 'FILE_ENTRY',
}
